const appConfig = {
    pathUserTemplate: 'https://eventqiu.com/assets/template/wcuagm_user_template.xlsx',
    pathCodeTemplate: 'https://eventqiu.com/assets/template/agm_code_template.xlsx',
    apiPrefix: 'https://wcuagm-api.eventqiu.com/api',
    authenticatedEntryPath: '/admin-eventqiu/user',
    unAuthenticatedEntryPath: '/admin-eventqiu/sign-in',
    adminPath: '/admin-eventqiu',
    tourPath: '/',
    notFound: '/not-found',
    locale: 'en',
    enableMock: false,
}

export default appConfig

